import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';



// 原因：
// 多次点击跳转同一个路由是不被允许的
//push
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

//replace
const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err);
};


Vue.use(Router);


const mainRoute = new Router({
  routes: [		
    {
      path: '/login',
      name: 'loign',
      component: () => import('@/components/Login'),
    },
    {
      path: '/info',
      name: 'info',
      component: () => import('@/views/info'),
    },
    {
      path: '/detail',
      name: 'detail',
      component: () => import('@/views/detail'),
    },
    {
      path: '/recruitList',
      name: 'recruitList',
      component: () => import('@/views/recruitList')
    },
		{
		  path: '/recruitDetail',
		  name: 'recruitDetail',
		  component: () => import('@/views/recruitDetail'),
		},
		{
		  path: '/cooperationDetail',
		  name: 'cooperationDetail',
		  component: () => import('@/views/cooperationDetail'),
		},
		{
		  path: '/EnterpriseInforDetail',
		  name: 'EnterpriseInforDetail',
		  component: () => import('@/views/EnterpriseInforDetail'),
		},
    
    {
      path: '/Home',
      name: 'home',
      redirect: '/Home/index',
      component: () => import('@/components/Home'),
      children: [
        {
          path: "index",
          name: "index",
          title: "欢迎页",
          component: () => import('@/views/admin/index'),
          meta: {
            title: "欢迎页"
          },
        },

        {
          path: "dataDeclarationList",
          name: "dataDeclarationList",
          title: "数据申报",
          component: () => import('@/views/admin/dataDeclarationList'),
          meta: {
            title: "数据申报"
          },
        },

        {
          path: "dataDeclarationListAdd",
          name: "dataDeclarationListAdd",
          title: "新增数据申报",
          component: () => import('@/views/admin/dataDeclarationListAdd'),
          meta: {
            title: "新增数据申报"
          },
        },

        {
          path: "statisticsReportList",
          name: "statisticsReportList",
          title: "统计报表",
          component: () => import('@/views/admin/statisticsReportList'),
          meta: {
            title: "统计报表"
          },
        },
      ]
    },
    {
      path: '/',
      name: 'index',
      // redirect: '/login',
      component: () => import('@/views/index'),
    },
  ],
});

mainRoute.beforeEach((to, from, next) => {
   // 判断是否手机浏览器
   console.log(navigator.userAgent)
  if (
    navigator.userAgent.match(/Mobi/i) ||
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/iPhone/i)
  ) {
    location.href = "https://www.stlhgx.com/mobile/"
  }
  else {
    return next();
  }

});


export default mainRoute;



// WEBPACK FOOTER //
// ./src/router/index.js